var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v(" Copyright ©2020-2026 沂水县刘家店子绿色农业专业合作社 ")])}
var staticRenderFns = []

export { render, staticRenderFns }